import Accordion from './modules/Accordion'
import Animations from './modules/Animations'
import EmbeddedVideos from './modules/EmbeddedVideos'
import Menu from './modules/Menu'
import MobileViewport from './modules/MobileViewport'
import Sliders from './modules/Sliders'
import Share from './modules/Share'

// Debug helper
const debug = true

if (!debug) {
  console.log = function () {}
}

export default class Main {
  constructor() {
    this.init()
  }

  init() {
    Sliders.init()
    Accordion.init()
    Menu.init()
    // Share.init()

    // run once when page loads
    window.addEventListener('DOMContentLoaded', () => {
      Animations.init()
      MobileViewport.init()
      EmbeddedVideos.init()
    })
  }
}

const main = new Main()

